var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"type":"area","height":"200px","options":_vm.chartOptions,"series":_vm.series}})
}
var staticRenderFns = []

export { render, staticRenderFns }